import { render, staticRenderFns } from "./work-index.vue?vue&type=template&id=3ad27454"
import script from "./work-index.vue?vue&type=script&lang=js"
export * from "./work-index.vue?vue&type=script&lang=js"
import style0 from "./work-index.vue?vue&type=style&index=0&id=3ad27454&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports